import { LuProtocol } from '@/types/controller'

/**
 * SCRUM-1032 QC round 3, item 1 — which commands a decoder's hardware can take.
 *
 * Autoswitch was offered on every output decoder. On mk2 line units the
 * hardware cannot do it and the call comes back 400 (Wei Woon, 21 Sep), so the
 * button's only outcome was an error toast.
 *
 * The protocol is resolved from the line-unit map, and on the config grid from
 * the decoder's own configuration as a fallback — both can come back with
 * nothing. `undefined`/0 therefore means "not resolved", not "not mk2", and
 * answers true: withholding a control that works is the worse of the two
 * mistakes, and the server still refuses what the hardware cannot do.
 */
export const canAutoswitch = (protocol: number | undefined | null): boolean =>
  Number(protocol) !== LuProtocol.Mk2
